function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "revoke-coach",
  transform: "translate(-1084 -382)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_19543",
  "data-name": "Group 19543",
  transform: "translate(0 70)"
}, /*#__PURE__*/React.createElement("g", {
  id: "bx-user-circle",
  transform: "translate(1082 310)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_31760",
  "data-name": "Path 31760",
  d: "M18,6A12.16,12.16,0,0,0,6,18a11.971,11.971,0,0,0,3.585,8.462,7.51,7.51,0,0,1,6.915-4.6h3a7.51,7.51,0,0,1,6.915,4.6A11.967,11.967,0,0,0,30,18,12.16,12.16,0,0,0,18,6Zm0,15a5.869,5.869,0,0,1-6-6,5.869,5.869,0,0,1,6-6,5.869,5.869,0,0,1,6,6A5.869,5.869,0,0,1,18,21Z",
  transform: "translate(0 0)",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_31761",
  "data-name": "Path 31761",
  d: "M19.5,24.858h-3a4.505,4.505,0,0,0-4.389,3.531,11.575,11.575,0,0,0,11.778,0A4.505,4.505,0,0,0,19.5,24.858Z",
  transform: "translate(0 0)",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_31762",
  "data-name": "Path 31762",
  d: "M18,3A15.2,15.2,0,0,0,3,18,15.073,15.073,0,0,0,9,29.886V30h.153a14.545,14.545,0,0,0,17.694,0H27v-.114A15.072,15.072,0,0,0,33,18,15.2,15.2,0,0,0,18,3ZM12.111,28.39A4.5,4.5,0,0,1,16.5,24.86h3a4.5,4.5,0,0,1,4.389,3.531,11.581,11.581,0,0,1-11.778,0Zm14.3-1.929a7.51,7.51,0,0,0-6.915-4.6h-3a7.51,7.51,0,0,0-6.915,4.6A11.971,11.971,0,0,1,6,18,12.16,12.16,0,0,1,18,6,12.159,12.159,0,0,1,30,18a11.971,11.971,0,0,1-3.585,8.462Z",
  fill: "#b0b2b3",
  stroke: "#fff",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_31765",
  "data-name": "Path 31765",
  d: "M18,9a5.869,5.869,0,0,0-6,6,5.869,5.869,0,0,0,6,6,5.869,5.869,0,0,0,6-6A5.869,5.869,0,0,0,18,9Zm0,9a2.87,2.87,0,0,1-3-3,2.87,2.87,0,0,1,3-3,2.87,2.87,0,0,1,3,3A2.87,2.87,0,0,1,18,18Z",
  transform: "translate(0 1)",
  fill: "#b0b2b3",
  stroke: "#fff",
  strokeWidth: 2
}))), /*#__PURE__*/React.createElement("line", {
  id: "Line_2275",
  "data-name": "Line 2275",
  x2: 20,
  y2: 18,
  transform: "translate(1090.5 388.5)",
  fill: "none",
  stroke: "#b0b2b3",
  strokeWidth: 1
}));

function SvgRevoke(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevoke);
export default __webpack_public_path__ + "static/media/revoke.72fbd379.svg";
export { ForwardRef as ReactComponent };